import classNames from 'classnames';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsTournamentsAverageSizes} from '../../../../../../actions/entities/statistics/tournaments';
import earthFlag from '../../../../../../assets/img/other/flag-earth.svg';
import Loader from '../../../../../../components/Loader';
import numeral from 'numeral';
import {sumBy} from 'lodash';

class TournamentsAverageSizeWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {lang: 'ALL'};
  }

  fetchStats() {
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsTournamentsAverageSizes({}, null, (type, error) =>
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
              `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
          }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  getLenght(data, filterField) {
    const values = Object.values(data).map(i => {
      return i.current;
    });
    const lengths = values.map(i => {
      return i[filterField];
    });
    return sumBy(lengths);
  }

  renderTournamentsAverageSize() {
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    let table = data && data[lang];

    if (!isFetching && table) {
      const privateLenght = this.getLenght(table.private, 'nbTournaments');
      const publicLenght = this.getLenght(table.public, 'nbTournaments');

      const totalPrivate = this.getLenght(table.private, 'totalSize');
      const totalPublic = this.getLenght(table.public, 'totalSize');

      const publicAverageSize = totalPublic / publicLenght;
      const privateAverageSize = totalPrivate / privateLenght;

      return (
        table && (
          <div className="mb-4">
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <tbody>
                  <tr className="text-center">
                    <td className="text-left">Privé</td>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(privateAverageSize).format('0,0.0')}
                    </th>
                  </tr>
                  <tr className="text-center">
                    <td className="text-left">Public</td>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(publicAverageSize).format('0,0.0')}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  render() {
    const {lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="userConnections-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-trophy" /> Taille moyenne des tournois
            </h3>
            <br />
            Taille des tournois (au moins en status live cette saison MPG)
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <button
                className="ml-2 inline btn btn-default"
                onClick={() => this.fetchStats()}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderTournamentsAverageSize()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.tournamentsAverageSizes,
  dispatch => ({dispatch}),
)(TournamentsAverageSizeWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Tournaments/AverageSize/index.js